// TODO move it where it's imported in app/components/
// Contracts Todo: rename to showContracts
export function showAgreements() {
  return new Promise((resolve) => {
    const agreementsController = document.querySelector(
      '[data-controller="cart--agreements"]'
    )

    const contractsController = document.querySelector(
      '[data-controller="contracts--contracts"]'
    )

    // Contracts Todo: We never expect Contracts and Agreements to live together!!
    // This should be temporary while we test and deploy contracts, removing agreements entirely.
    if (contractsController) {
      contractsController.dispatchEvent(
        new CustomEvent('contracts:show', { detail: { callback: resolve } })
      )
      return
    } else if (agreementsController) {
      agreementsController.dispatchEvent(
        new CustomEvent('agreements:show', { detail: { callback: resolve } })
      )
      return
    } else {
      resolve(true)
    }
  })
}
